import React from 'react'

import { Helmet } from 'react-helmet'

import Header from '../components/header'
import ListItem from '../components/list-item'
import FeatureCard from '../components/feature-card'
import Footer from '../components/footer'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Chamunda Brokers.</title>
        <meta property="og:title" content="Chamunda Brokers." />
      </Helmet>
      <Header></Header>
      <div className="home-hero" >
        <div className="home-container01" id="home">
          <div className="home-card">
            <h1 className="home-text HeadingOne">Chamunda Brokers.</h1>
            <h6 className="home-text01 HeadingThree">Choose the best</h6>
            <span className="home-text02">
              <span className='Lead'>
                At Chamunda Brokers, we are not just suppliers; we are partners
                in your success. Our team of experts is dedicated to ensuring
                that you receive the best products and services possible.
              </span>
            </span>
          </div>
        </div>
      </div>
      <section className="home-contaier" id="our-products">
        <div className="home-container02">
          {/* <div className="home-container03">
            <svg viewBox="0 0 1024 1024" className="home-icon">
              <path d="M363.722 722.052l41.298-57.816-45.254-45.256-57.818 41.296c-10.722-5.994-22.204-10.774-34.266-14.192l-11.682-70.084h-64l-11.68 70.086c-12.062 3.418-23.544 8.198-34.266 14.192l-57.818-41.298-45.256 45.256 41.298 57.816c-5.994 10.72-10.774 22.206-14.192 34.266l-70.086 11.682v64l70.086 11.682c3.418 12.060 8.198 23.544 14.192 34.266l-41.298 57.816 45.254 45.256 57.818-41.296c10.722 5.994 22.204 10.774 34.266 14.192l11.682 70.084h64l11.68-70.086c12.062-3.418 23.544-8.198 34.266-14.192l57.818 41.296 45.254-45.256-41.298-57.816c5.994-10.72 10.774-22.206 14.192-34.266l70.088-11.68v-64l-70.086-11.682c-3.418-12.060-8.198-23.544-14.192-34.266zM224 864c-35.348 0-64-28.654-64-64s28.652-64 64-64 64 28.654 64 64-28.652 64-64 64zM1024 384v-64l-67.382-12.25c-1.242-8.046-2.832-15.978-4.724-23.79l57.558-37.1-24.492-59.128-66.944 14.468c-4.214-6.91-8.726-13.62-13.492-20.13l39.006-56.342-45.256-45.254-56.342 39.006c-6.512-4.766-13.22-9.276-20.13-13.494l14.468-66.944-59.128-24.494-37.1 57.558c-7.812-1.892-15.744-3.482-23.79-4.724l-12.252-67.382h-64l-12.252 67.382c-8.046 1.242-15.976 2.832-23.79 4.724l-37.098-57.558-59.128 24.492 14.468 66.944c-6.91 4.216-13.62 8.728-20.13 13.494l-56.342-39.006-45.254 45.254 39.006 56.342c-4.766 6.51-9.278 13.22-13.494 20.13l-66.944-14.468-24.492 59.128 57.558 37.1c-1.892 7.812-3.482 15.742-4.724 23.79l-67.384 12.252v64l67.382 12.25c1.242 8.046 2.832 15.978 4.724 23.79l-57.558 37.1 24.492 59.128 66.944-14.468c4.216 6.91 8.728 13.618 13.494 20.13l-39.006 56.342 45.254 45.256 56.342-39.006c6.51 4.766 13.22 9.276 20.13 13.492l-14.468 66.944 59.128 24.492 37.102-57.558c7.81 1.892 15.742 3.482 23.788 4.724l12.252 67.384h64l12.252-67.382c8.044-1.242 15.976-2.832 23.79-4.724l37.1 57.558 59.128-24.492-14.468-66.944c6.91-4.216 13.62-8.726 20.13-13.492l56.342 39.006 45.256-45.256-39.006-56.342c4.766-6.512 9.276-13.22 13.492-20.13l66.944 14.468 24.492-59.13-57.558-37.1c1.892-7.812 3.482-15.742 4.724-23.79l67.382-12.25zM672 491.2c-76.878 0-139.2-62.322-139.2-139.2s62.32-139.2 139.2-139.2 139.2 62.322 139.2 139.2c0 76.878-62.32 139.2-139.2 139.2z"></path>
            </svg>
          </div> */}
          <h2 className="home-text62 HeadingTwo">Our Products</h2>
          <span className="home-text63" style={{
            fontSize: '18px',
            letterSpacing: ".5px",
             textAlign: 'center'
          }}>
            Our products are the result of meticulous farming practices,
            stringent quality control, and a deep understanding of cotton&apos;s
            diverse applications. Also, we offer various grades and varieties of
            cotton Fibers &amp; and seeds, ensuring that you always find the
            perfect fit for your needs.
          </span>
        </div>
        <div className="home-container04">
          <div className="home-container05">
            <div className="home-container06">
              <h1 className="home-text64 HeadingOne">Cotton Fiber</h1>
            </div>
          </div>
          <div className="home-container07">
            <ListItem
              title="3. Social Conversions"
              new_prop="Cotton Fiber"
              description="As we have a lot of experience in this field with the emerging name, we currently have a huge customer base for cotton Fibers fulfilling the demands of the consumer. As you get more choices the more the chances of getting desirable results. We are currently operating with the best Spinning Units across the globe."
            ></ListItem>
          </div>
        </div>
        <div className="home-divider"></div>
        <div className="home-container08">
          <div className="home-container09">
            <ListItem
              title="1. Always in Sync"
              new_prop="Cotton Seeds"
              description="Cotton seeds have a massive market over our central zone where we being an efficient supplier fulfil the demands of the market. The cotton seeds business is been successfully carried out by us with the best buyers and sellers in the market."
            ></ListItem>
          </div>
          <div className="home-container10">
            <div className="home-container11">
              <h1 className="home-text65">
                <span className="HeadingOne">Cotton Seeds</span>
                <br></br>
              </h1>
            </div>
          </div>
        </div>
      </section>
      <img
        alt="image"
        src="https://images.unsplash.com/photo-1633873972250-e69cd8b5e31c?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDZ8fGNvdHRvbnxlbnwwfHx8fDE2OTgyMTE1NjF8MA&amp;ixlib=rb-4.0.3&amp;h=1500"
        className="home-image"
      />
      <section className="home-container12" id="about-us">
        <div className="home-container13">
          <h1 className="home-text68">
            <span className="HeadingOne">About Us</span>
            <br></br>
          </h1>
          <span className="home-text71" style={{
            fontSize: '18px',
            letterSpacing: ".5px"
          }}>
            At Chamunda Brokers, we pride ourselves on being the premier
            destination for high-quality cotton bales and cotton-related
            products. With decades of experience in the cotton industry,
            we have established ourselves as a reliable partner for
            farmers, ginners, spinning mills, oil mills and businesses
            across the globe. Our commitment to excellence,
            sustainability, and customer satisfaction sets us apart in the
            industry
          </span>
        </div>
        <div className="home-container14">
          <div className="home-container15">
            <img
              alt="image"
              src="https://images.unsplash.com/photo-1570993127499-f9b1e9fc4a63?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDMyfHxjb3R0b24lMjUyMHNoZWV0c3xlbnwwfHx8fDE2OTgyMjI1NzF8MA&amp;ixlib=rb-4.0.3&amp;w=1100"
              className="home-image1"
            />
            <span className="home-text72">
              &quot;At Chamunda Brokers, we are not just suppliers; we are
              partners in your success.&quot;
            </span>
            <div className="home-container17">
              <h3 className="HeadingTwo">
                Our Mission
              </h3>
              <p>
                <br></br>
                <span>
                  Our goal at Cotton Fiber dealer is to be a trustworthy and sustainable partner in the international cotton business. While preserving the highest standards of quality, integrity, and environmental responsibility, we are committed to offering outstanding quality cotton bales and related goods. Our goal is to develop enduring relationships with our clients that are based on honesty, openness, and a dedication to quality.
                </span>
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
          <div className="home-container16">
            <img
              alt="image"
              src="https://images.unsplash.com/photo-1534779182058-26272ba6a04f?ixid=M3w5MTMyMXwwfDF8c2VhcmNofDUzfHxjb3R0b24lMjUyMHNoZWV0c3xlbnwwfHx8fDE2OTgyMjI1OTJ8MA&amp;ixlib=rb-4.0.3&amp;w=1100"
              className="home-image2"
            />
            <div className="home-container17">
              <h3 className="HeadingTwo">
                Our Vision
              </h3>
              <p>
                <br></br>
                <span>
                  At Chamunda Brokers, we pride ourselves on being the premier
                  destination for high-quality cotton bales and cotton-related
                  products. With decades of experience in the cotton industry,
                  we have established ourselves as a reliable partner for
                  farmers, ginners, spinning mills, oil mills and businesses
                  across the globe. Our commitment to excellence,
                  sustainability, and customer satisfaction sets us apart in the
                  industry.
                </span>
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="home-testimonials" id="why-us">
        <div className="home-container18">
          {/* <div className="home-container19"> */}
          <div className="home-container20">
            <div className="home-container21">
              <h2 className="home-text79 HeadingOne">Why us ?</h2>
              <p className="home-text80">
                <span>
                  Our products are the result of meticulous farming practices,
                  stringent quality control, and a deep understanding of
                  cotton&apos;s diverse applications. Also, we offer various
                  grades and varieties of cotton Fibers &amp; and seeds,
                  ensuring that you always find the perfect fit for your
                  needs.
                </span>
                <br className="Lead"></br>
              </p>
              <p className="home-text83 Body">
                &quot;Take up one idea. Make that one idea your life - think
                of it, dream of it, live on that idea. Let the brain, muscles,
                nerves, every part of your body, be full of that idea, and
                just leave every other idea alone. This is the way to success.
                A single rose can be my garden... a single friend, my
                world.&quot;
              </p>
            </div>
            <div className="home-container22">
              <FeatureCard
                image_src="/person1.svg"
                new_prop="Sustainability"
                text="Committed to sustainable cotton sales, considering environmental, economic, social aspects."
              ></FeatureCard>
              <FeatureCard
                text="Customizable solutions tailored for unique customer packaging and delivery needs."
                title="Less Code"
                image_src="/rocket1.svg"
                new_prop="Custom Solutions"
              ></FeatureCard>
              <FeatureCard
                text="Global network ensures prompt, efficient delivery of cotton bales worldwide."
                title="Fully Responsive"
                image_src="/credit%20card1.svg"
                new_prop="Huge Customer Base"
              ></FeatureCard>
              <FeatureCard
                text="Carefully sourced cotton, rigorously checked, ensuring international quality standards."
                title="Components"
                image_src="/cube1.svg"
                new_prop="Strict Process "
              ></FeatureCard>
            </div>
          </div>
          {/* </div> */}
          <div className="home-logos"></div>
        </div>
        <img alt="image" src="/waves-white.svg" className="home-image3" />
        <img alt="image" src="/top.svg" className="home-top-wave-image" />
      </section>
      <Footer></Footer>
    </div>
  )
}

export default Home
